import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import type { AppSettings } from './useAppSettings'

async function fetchAppSettings(): Promise<AppSettings> {
  const [settingsResult, referralResult] = await Promise.all([
    supabase.from('app_settings').select('max_stamps_per_transaction, receipt_reference_enabled, cashier_stamp_correction_enabled, cashier_reward_restore_enabled').single(),
    supabase.from('referral_config').select('enabled').single(),
  ])

  if (settingsResult.error) throw settingsResult.error
  if (referralResult.error) throw referralResult.error

  return {
    maxStamps: settingsResult.data.max_stamps_per_transaction,
    receiptReferenceEnabled: settingsResult.data.receipt_reference_enabled,
    referralProgramEnabled: referralResult.data.enabled,
    cashierStampCorrectionEnabled: settingsResult.data.cashier_stamp_correction_enabled,
    cashierRewardRestoreEnabled: settingsResult.data.cashier_reward_restore_enabled,
  }
}

export function useAppSettingsQuery() {
  return useQuery({
    queryKey: ['app-settings'],
    queryFn: fetchAppSettings,
  })
}